import api from '../config/api';
import {
  Wallet,
  Transaction,
  PayoutSetting,
  WithdrawalRequest,
  Withdrawal,
  PaginatedResponse,
} from '../types';

export const walletService = {
  // Get wallet
  getWallet: async (): Promise<{ success: boolean; data: Wallet }> => {
    const response = await api.get('/wallet/');
    return response.data;
  },

  // Get transactions
  getTransactions: async (params?: {
    page?: number;
    limit?: number;
    type?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<PaginatedResponse<Transaction>> => {
    const response = await api.get('/wallet/transactions', { params });
    return response.data;
  },

  // Get payout settings
  getPayoutSettings: async (): Promise<{ success: boolean; data: PayoutSetting[] }> => {
    const response = await api.get('/wallet/payout-settings');
    return response.data;
  },

  // Add payout setting
  addPayoutSetting: async (data: Partial<PayoutSetting>): Promise<{ success: boolean; data: PayoutSetting }> => {
    const response = await api.post('/wallet/payout-settings', data);
    return response.data;
  },

  // Delete payout setting
  deletePayoutSetting: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/wallet/payout-settings/${id}`);
    return response.data;
  },

  // Request withdrawal
  requestWithdrawal: async (data: WithdrawalRequest): Promise<{ success: boolean; data: Withdrawal }> => {
    const response = await api.post('/wallet/withdraw', data);
    return response.data;
  },

  // Get withdrawals
  getWithdrawals: async (params?: {
    page?: number;
    limit?: number;
    status?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<PaginatedResponse<Withdrawal>> => {
    const response = await api.get('/wallet/withdrawals', { params });
    return response.data;
  },

  // Get bank list
  getBankList: async (country: string): Promise<{ success: boolean; data: any[] }> => {
    const response = await api.get('/wallet/banks', { params: { country } });
    return response.data;
  },

  // Fund wallet
  fundWallet: async (data: { amount: number; paymentProvider: string }): Promise<{ success: boolean; data: any }> => {
    const response = await api.post('/wallet/fund', data);
    return response.data;
  },
};
